import React, { Component } from 'react'
import noImage from '../../images/no_image.png'
import { Link } from 'react-router-dom'
import UserBlock from '../Users/UserBlock.js'
import _ from 'lodash'
import TitleBar from '../TitleBar'
import moment from 'moment'
import getLabel from '../../utilities/label.js'

export default class Messages extends Component {
  constructor(props) {
    super(props)
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    this.state = {
      refreshButton: refreshButton
    }
    this.refresh = this.refresh.bind(this)
    this.getMessageComponent = this.getMessageComponent.bind(this)
    this.props.setActiveTab('homepage')
    window.trackPage('MessageThreadsScreen')
  }

  getImage(user_id) {
    var user = this.getUserFromUserID(user_id)
    if(user.photo) {
      return <img className='rounded-circle' height="80" src={user.photo} alt='' />
    } else {
      return <img height="80" src={noImage} alt='' />
    }
  }

  getMessages() {
    let messageThreads = []
    let currentUserID = window.currentUser.user_id
    let messages = this.props.messages.messages.slice().reverse()
    _.each(messages, (message) => {
      let isSender = message.sender_user_id === currentUserID
      let otherUserID = isSender ?
        message.recipient_user_id :
        message.sender_user_id
      let messageThread = messageThreads.find( (thread) => {
        return thread.otherUserID === otherUserID
      })
      if (!messageThread) {
        messageThread = {
          otherUserID: otherUserID,
          dataCount: 0,
          mostRecentMessage: message
        }
        messageThreads.push(messageThread)
      }
      if (!message.has_been_read && !isSender) {
        messageThread.dataCount += 1
      }
    })
    return messageThreads.length ?
      messageThreads.map(this.getMessageComponent) :
      <div style={{ textAlign: 'center'}}>{ getLabel('no_results_found') }</div>
  }

  getMessageComponent(messageThread) {
    const message = messageThread.mostRecentMessage
    const otherUserID = messageThread.otherUserID
    const timeframe = this.getTimeframe(message.created_at)
    if (messageThread.dataCount > 0) {
      return (
        <div
          key={otherUserID}
          data-count={ messageThread.dataCount }
          className='list-messages'>
          <div className='list-message-row'>
            <Link to={'/message/' + otherUserID} >
              <UserBlock user={this.getUserFromUserID(otherUserID)} />
              <div className='list-message'>{message.message}</div>
              <div className='timeframe'>{ timeframe }</div>
            </Link>
          </div>
          <hr />
        </div>
      )
    } else {
      return (
        <div
          key={otherUserID}
          className='list-messages with-arrow'>
          <div className='list-message-row'>
            <Link to={'/message/' + otherUserID} >
              <UserBlock user={this.getUserFromUserID(otherUserID)} />
              <div className='list-message'>{message.message}</div>
              <div className='timeframe'>{ timeframe }</div>
              <i className='fa fa-angle-right'></i>
            </Link>
          </div>
          <hr />
        </div>
      )
    }
  }

  getTimeframe(time) {
    const now = moment()
    const createdAt = moment(time)
    const minutesAgo = now.diff(createdAt, 'minutes')
    let timeframe = ''
    if (minutesAgo < 60) {
      timeframe = `${ minutesAgo }m`
    } else {
      const hoursAgo = now.diff(createdAt, 'hours')
      if (hoursAgo < 24) {
        timeframe = `${ hoursAgo }h`
      } else {
        const daysAgo = now.diff(createdAt, 'days')
        if (daysAgo < 31) {
          timeframe = `${ daysAgo }d`
        } else {
          timeframe = '30d+'
        }
      }
    }
    return timeframe
  }

  getUserFromUserID(user_id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(user_id, 10)})
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({
      refreshButton: refreshButton
    })
    this.props.updateResource({
      key: 'messages',
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  render() {
    return (
      <div className="message-page">
        <TitleBar
          title={ this.props.pageTitle }
          leftButtonLabel={ this.props.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />

        {this.getMessages()}
 			<pre className="debug-json">{JSON.stringify(this.props.messages, false, 2)}</pre>
      </div>
    )
  }
}
